<template>
  <vs-row>
    <form>
      <vs-row>
        <vs-input label-placeholder="Extra név (kötelező)" v-model="addon.AddonName"></vs-input>
      </vs-row>
      <vs-row>
        <vs-input label-placeholder="Extra leírás" v-model="addon.AddonDescription"></vs-input>
      </vs-row>
      <vs-row>
        <vs-input label-placeholder="Extra ár (kötelező)" v-model="addon.AddonPrice"></vs-input>
      </vs-row>
      <vs-row class="justify-content-center">
        <vs-button @click.native="save()" color="success" type="gradient" :disabled="isNotSaveable()">Mentés</vs-button>
      </vs-row>
    </form>
  </vs-row>
</template>

<script>
import {axiosInstance} from "@/main";

export default {
  name: "edit_addon",
  props: ['selected'],
  data() {
    return {
      addon: ''
    }
  },
  watch: {
    selected() {
      this.addon = {...this.selected}
    }
  },
  methods: {
    save() {
      let self = this;
      this.$vs.dialog({
        type: 'confirm',
        color: 'success',
        title: `Megerősítés`,
        text: 'Valóban menti a módosításokat?',
        acceptText: 'Igen',
        cancelText: 'Nem',
        accept: function () {
          axiosInstance
              .post('admin/addonController.php', self.addon, {
                withCredentials: true,
              })
              .then((resp) => {
                self.$vs.notify({
                  title: 'Rendszerüzenet',
                  position: 'top-right',
                  text: resp.data.status === 'OK' ? 'Sikeres mentés.' : 'Sikertelen mentés. ' + resp.data.message,
                  color: resp.data.status === 'OK' ? 'success' : 'danger',
                  icon: resp.data.status === 'OK' ? 'check_box' : 'error'
                });
                self.$parent.$emit('closemodal');
              })
              .catch((err) => {
                if (err.response.status === 401)
                  self.$root.exterminatus(err.response.data.message);
                else {
                  self.$vs.notify({
                    title: 'Rendszerüzenet',
                    position: 'top-right',
                    text: err.response.data.message,
                    color: 'danger',
                    icon: 'error'
                  });
                }
              });
        }
      });
    },
    isNotSaveable() {
      return !this.addon.AddonName || !Number.isInteger(parseInt(this.addon.AddonPrice));
    }
  }
}
</script>

<style scoped>
.vs-input {
  margin-top: 15px;
  margin-bottom: 15px;
  width: 100%;
}

.vs-textarea-primary {
  margin-top: 15px;
}

form {
  width: 100%;
}
</style>